import { render, staticRenderFns } from "./IptaPackagesField.vue?vue&type=template&id=9ed4c84a&"
import script from "./IptaPackagesField.vue?vue&type=script&lang=js&"
export * from "./IptaPackagesField.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports